import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Description = styled.p`
  color: #6d747b;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 20px;
`;

export const SearchContainer = styled.div`
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  width: 100%;
  max-width: 400px;
  padding: 10px 14px;
  border: 1px solid #d3d8de;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #0b99e6;
  }

  &::placeholder {
    color: #9ea6ad;
  }
`;

export const ItemList = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  margin-bottom: 20px;
`;

export const ItemRow = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #e1e6eb;
  background: ${({ $selected }) => ($selected ? 'rgba(11, 153, 230, 0.08)' : '#fff')};
  border-left: 3px solid ${({ $selected }) => ($selected ? '#0b99e6' : 'transparent')};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ $selected }) => ($selected ? 'rgba(11, 153, 230, 0.12)' : '#f7f8fa')};
  }
`;

export const ItemImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 12px;
  background: #f7f8fa;
`;

export const ItemImagePlaceholder = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 4px;
  margin-right: 12px;
  background: #e1e6eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ea6ad;
  font-size: 12px;
`;

export const ItemInfo = styled.div`
  flex: 1;
`;

export const ItemTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #121516;
  margin-bottom: 4px;
`;

export const ItemMeta = styled.div`
  font-size: 12px;
  color: #6d747b;
`;

export const ItemStatus = styled.span<{ $active?: boolean }>`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
  background: ${({ $active }) => ($active ? '#e8f5e9' : '#f5f5f5')};
  color: ${({ $active }) => ($active ? '#2e7d32' : '#757575')};
`;

export const EmptyState = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #6d747b;
`;

export const LoadingState = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #6d747b;
`;

export const SelectedInfo = styled.div`
  background: #f0f7ff;
  border: 1px solid #0b99e6;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectedLabel = styled.span`
  font-size: 14px;
  color: #121516;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: #0b99e6;
  font-size: 13px;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;
